export class DemanderESignature 
{
    subItemId:String;
    receiverEmail:String;
    message:String;
}
  